import { lazy } from 'react';

const CharityFoodSafetyQThreeRoute = lazy(
  () =>
    import('../components/steps/charity-food-safety-step/charity-food-safety-q3-step/CharityFoodSafetyQThree'),
);

export default CharityFoodSafetyQThreeRoute;
